import { useQuery } from "@tanstack/react-query";
import { getAllActivities } from "../../api/activities";

const useActivities = () => {
  const { data } = useQuery({
    queryKey: ["activities"],
    queryFn: getAllActivities,
  });

  return { activities: data?.data || [] };
};

export default useActivities;
